export default {
    'diagram3b3-6': {
        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'Not everybody can be trusted to obey tacit ethical rules ',
        'element_1_2': 'Organizational hierarchies supply the rules and sanctions',
        'element_1_3': 'We should not celebrate the breakdown of organizational hierarchy and authority',
        'element_1_4': 'They must be coerced by explicit rules and sanctions ',
        'element_1_5': 'Communities depend on mutual trust, and will not arise spontaneously without it',
        'element_1_6': 'Some asocial',
        'element_1_7': 'Some free riders',
      'hint-title': 'Hint',
      'resubmit-title': 'Resubmit'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b3/diagram6/i18n/en.js